import { createActions } from "redux-actions"

export const { poetri } = createActions({
  POETRI: {
    GET_COUNTRIES: () => ({}),
    GET_COUNTRIES_RESPONSE: countries => ({ countries }),
  },
})
